import "./Content.scss";

import React, { ReactNode } from "react";
import clsx from "clsx";

import ErrorPanel from "../../common/ErrorPanel/ErrorPanel";
import ErrorBoundary from "../../util/ErrorBoundary/ErrorBoundary";

export interface ContentProps
	extends Omit<React.HTMLProps<HTMLDivElement>, "ref"> {
	children?: ReactNode;
}

const Content = (props: ContentProps) => {
	const { children, className, ...otherProps } = props;

	return (
		<ErrorBoundary className={clsx("Content", className)} {...otherProps}>
			{(error: Error | null) =>
				error ? <ErrorPanel error={error} /> : children || null
			}
		</ErrorBoundary>
	);
};

export default React.memo(Content);
